import React from "react";
import withLocalization from "../../../hoc/with-localization";
const PrmTablePatientBirth = props => {
    const {
        birthday,
        age: { years, months },
        loc
    } = props;
    return (
        <table className="prm-table prm-table-patient-birth">
            <tbody>
                <tr>
                    <td className="prm-title prm-title-invert">{loc("report.patient.birthday")}</td>
                    <td className="prm-data prm-data-invert">{birthday}</td>
                    <td className="prm-gap"></td>
                    {years ? (
                        <>
                            <td className="prm-title prm-title-invert">{loc("report.patient.age")}</td>
                            <td className="prm-data prm-data-invert">{years}</td>
                        </>
                    ) : months ? (
                        <>
                            <td className="prm-title prm-title-invert">{loc("report.patient.age")}</td>
                            <td className="prm-data prm-data-invert">{months + " " + loc("units.months")}</td>
                        </>
                    ) : (
                        <>
                            <td className="prm-title prm-title-invert">{loc("report.patient.age")}</td>
                        </>
                    )}
                </tr>
            </tbody>
        </table>
    );
};

export default withLocalization(PrmTablePatientBirth);
